var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d63b8ca4203a3dd8557351f6732861215aa1f43f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["blog-devsbrasil@devsbrasil-dl"]={id:"d63b8ca4203a3dd8557351f6732861215aa1f43f"};
      